import { render, staticRenderFns } from "./ProgramSummaryTable.vue?vue&type=template&id=098fc887&scoped=true"
import script from "./ProgramSummaryTable.vue?vue&type=script&lang=js"
export * from "./ProgramSummaryTable.vue?vue&type=script&lang=js"
import style0 from "./ProgramSummaryTable.vue?vue&type=style&index=0&id=098fc887&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098fc887",
  null
  
)

export default component.exports